export default __webpack_public_path__ + "static/media/Supercharge-Your-Career-Generator.3488da20.png";